module.exports = __webpack_public_path__ + "static/media/asc-minus.edcbd2b7.svg";